<template>
  <div class="variable-table-box">
    <RexModalLabel :primaryLabel="$t('notification.variablesSupported')" />
    <RexTableCompV2
      :headers="headers"
      :items="items"
      height="100%"
      variant="secondary"
      class="variable-table-comp"
    />
  </div>
</template>

<script>
import RexTableCompV2 from '@/rex-components/rex-TableCompV2.vue';
import RexModalLabel from '@/rex-components/rex-modal-label.vue';

import {
  addChannelVariableTableHeaders,
  addChannelVariableTableItems,
  addTaggingChannelVariableTableItems,
} from '@/components/Notification/notification.type';

export default {
  components: { RexTableCompV2, RexModalLabel },
  props: {
    isTagging: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  created() {
    this.headers = addChannelVariableTableHeaders();
    this.items = this.isTagging
      ? addTaggingChannelVariableTableItems()
      : addChannelVariableTableItems();
  },
  watch: {
    isTagging(newVal) {
      this.items = newVal
        ? addTaggingChannelVariableTableItems()
        : addChannelVariableTableItems();
    },
  },
};
</script>

<style lang="scss" scoped>
.variable-table-box {
  @include flex-column;
  height: 100%;
}
.variable-table-comp {
  margin-top: 0.5rem;
  flex: 1;
}
:deep(.body-tr-secondary) {
  font-size: 1rem;
}
</style>
